export const TRIVIA_FEEDBACK_CHROME_FLEX = "1 0 auto";
export const TRIVIA_FEEDBACK_VERDICT_FLEX = "1 1 auto";
export const TRIVIA_FEEDBACK_FOOTER_FLEX = "0 0 auto";
export const TRIVIA_QUESTION_PANE_FEEDBACK_FLEX = "0 1 auto";
